import * as constants from '../constants';

const defaultState: any = {
    teamLeads: {
        data: [],
    },
    fleets: {},
};

export default function cmReducer(state = defaultState, action: any) {
    switch (action?.type) {
        case constants.SET_CM_TEAM_LEADS:
            return { ...state, teamLeads: action.payload };
        case constants.SET_TL_FLEETS:
            return { ...state, fleets: action.payload };
        default:
            return state;
    }
}
